export default function print() {
  try {
    // Print for Safari browser
    // Marked depreciated but no viable alternative exists
    document.execCommand('print', false, null);
  } catch {
    window.print();
  }
}
